export default __webpack_public_path__ + "static/media/About_ProCompIllustration.f98d9289.png";